
/*jshint esversion: 6 */

import { Route, Routes } from 'react-router-dom';
import ReactGA from 'react-ga';
import './App.css';
import Header from './components/Header/Header';
import Home from './components/Pages/Home';
import About from './components/Pages/About';
import Portfolio from './components/Pages/Portfolio';
import Contact from './components/Pages/Contact';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Blogs from './components/Pages/Blogs';
import Manufacture from './components/Pages/Details/Manufacture';
import NotFound from './components/Pages/NotFound/NotFound';
import Doctors from './components/Pages/Details/Doctors';
import Electronics from './components/Pages/Details/Electronics';
import Itracker from './components/Pages/Details/Itracker';
import Dashboard from './components/Pages/Dashboard/Dashboard';
import AddProjects from './components/Pages/Dashboard/AddProjects';
import UpdateProjects from './components/Pages/Dashboard/UpdateProjects';
import DashboardDetails from './components/Pages/Dashboard/DashboardDetails';
import AllProject from './components/Pages/Dashboard/AllProject';
import { Toaster } from 'react-hot-toast';
import FeaturedBlogs from './components/Pages/Dashboard/FeaturedBlogs';
import UsersFeedback from './components/Pages/Dashboard/UsersFeedback/UsersFeedback';
import ProtectedRoute from './auth/ProtectedRoute';
import AdminCredential from './auth/AdminCredential';
import Layout from './Layout/Layout';
import AnimatedCursor from "react-animated-cursor"

function App() {

// Initialize Google Analytics with your tracking ID
ReactGA.initialize('G-9CWWZDJSLL');

  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
    AOS.init();
  }, []);

  return (
    <div className="App">
      
      {/* <AnimatedCursor  /> */}
      <Layout>
<Header>
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="about" element={<About/>} />
      <Route path="portfolio" element={<Portfolio/>} />
      <Route path="blog" element={<Blogs/>} />
      <Route path="contact" element={<Contact/>} />
      <Route path="manufacture" element={<Manufacture/>} />
      <Route path="iTracker" element={<Itracker/>} />
      <Route path="doctor" element={<Doctors/>} />
      <Route path="elect" element={<Electronics/>} />

     
      <Route path="dashboard" element={<Dashboard />} >
          <Route index element={<DashboardDetails></DashboardDetails>}></Route>
          <Route path="allProject" element={<AllProject></AllProject>}></Route>
          <Route path="addProject" element={<AddProjects></AddProjects>}></Route>
          {/* <Route path="addProject" element={<ProtectedRoute   element={<AddProjects />} />} /> */}
          <Route path="updateProject" element={<UpdateProjects></UpdateProjects>}></Route>
          <Route path="blogs" element={<FeaturedBlogs></FeaturedBlogs>}></Route>
          <Route path="users-feedback" element={<UsersFeedback></UsersFeedback>}></Route>
          
        </Route>

        {/* <Route path="admin-credential" element={<AdminCredential/>} /> */}
     
      <Route path="*" element={<NotFound/>} />
    </Routes>
    <ScrollToTop/>
    <Toaster position="top-center" toastOptions={{ style: { background: '#333', color: '#fff' } }} />
    </Header>
      </Layout>
    </div>
  );
}

export default App;
